import { divIcon, Layer, Marker, Path } from "leaflet";
import { PaintTypes } from "../style";
import { Icon, ThemeProvider, useTheme } from "@mui/material";
import { listIcons } from "../icons";
import { Actions } from "./layers";

export const setHidroStyle = (layer: Layer, style: PaintTypes, actions?: Actions) => {

  const functions: { [key: string]: () => void; } = {
    click: () => {
      if (actions?.onClick) actions.onClick(layer);
    },
    dblclick: () => {
      if (actions?.onDoubleClick) actions.onDoubleClick(layer);
    },
    mousedown: () => {
      if (actions?.onMouseDown) actions.onMouseDown(layer);
    },
    mouseup: () => {
      if (actions?.onMouseUp) actions.onMouseUp(layer);
    },
    mouseover: () => {
      if (actions?.onMouseOver) actions.onMouseOver(layer);
    },
    mouseout: () => {
      if (actions?.onMouseOut) actions.onMouseOut(layer);
    },
    mousemove: () => {
      if (actions?.onMouseMove) actions.onMouseMove(layer);
    },
    contextmenu: () => {
      if (actions?.onContextMenu) actions.onContextMenu(layer);
    },
    preclick: () => {
      if (actions?.onPreClick) actions.onPreClick(layer);
    },
  };

  if (layer instanceof Path) {
    layer.setStyle(style);
    // Ao sair de cima
    functions['mouseout'] = () => {
      layer.setStyle(style);
      if (actions?.onMouseOut) actions.onMouseOut(layer);
    };

    if (style.paintHovered) {
      functions['mouseover'] = () => {
        layer.setStyle(style.paintHovered ?? {});
        if (actions?.onMouseOver) actions.onMouseOver(layer);
      };
    }

    if (style.paintClick) {
      functions['click'] = () => {
        layer.setStyle(style.paintClick ?? {});
        if (actions?.onClick) actions.onClick(layer);
      };
    }
  } else if (layer instanceof Marker && "iconStr" in style) {
    if (style.icon) {
      layer.setIcon(style.icon);
    } else if (style.iconStr) {
      const icon = (
        <Icon sx={{
          fontSize: style.iconSize,
          color: style.color,
        }}>
          {listIcons[style.iconStr ?? "PinDrop"]}
        </Icon>
      );

      layer.setIcon(divIcon({
        html: window.JSXToHTML(icon),
        className: '',
        iconAnchor: [(style.iconSize ?? 20) / 2, (style.iconSize ?? 20) / 2],
      }));
    }
  }

  for (const name in functions) {
    layer.on(name, functions[name]);
  }
};

interface PropsIcon {
  text: string;
  iconSize: number;
  children?: React.ReactNode;
}
export const IconData: React.FC<PropsIcon> = ({ children }) => {
  const theme = useTheme();
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};